import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import s from './s.module.less';
import { TMedication } from '../../../type';

interface Props {
    index: number;
    med: TMedication;
    onEdit?: (med: TMedication) => void;
    onRemove?: (med: TMedication) => void;
}

const MedicationItem: React.FC<Props> = ({ med, index, onEdit, onRemove }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: (med as any)._tempId || med.name,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        boxShadow: isDragging ? '0 4px 12px rgba(0,0,0,0.1)' : 'none',
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} className={s.card}>
            <div className={s.header}>
                <div className={s.title}>
                    <span className={s.dragHandle} {...listeners}><MenuOutlined /></span>
                    Medication {index + 1}
                </div>
                <div className={s.buttons}>
                    <Button type="text" className={s.removeButton} onClick={() => onRemove?.(med)}>Remove</Button>
                    <Button onClick={() => onEdit?.(med)}>Edit</Button>
                </div>
            </div>
            <div className={s.content}>
                <div className={s.field}>
                    <div className={s.label}>Page link</div>
                    <div className={s.value}>{med?.callToActionLink || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Specialty</div>
                    <div className={s.value}>{med?.name || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Name</div>
                    <div className={s.value}>{med?.name || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Subtext</div>
                    <div className={s.value}>{med?.details || '-'}</div>
                </div>
            </div>
        </div>
    );
};

export default MedicationItem;
